import { Box, Card, Typography } from "@mui/material";
import { DocumentCardItem } from "../../../types";

type DocumentCardProps = {
    documentCardItem: DocumentCardItem;
};

export default function DocumentCard({ documentCardItem }: DocumentCardProps) {
    const { name, year, actions } = documentCardItem;
    const { download } = actions;

    return (
        <Card
            sx={{
                display: "flex",

                padding: "1rem",
                alignItems: "center",
                gap: "1rem",
                alignSelf: "stretch",
                borderRadius: "1rem",
                background: "#FFF",
                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
            }}
        >
            {/* <CardContent
                sx={{
                    padding: 0,
                    ":last-child": {
                        paddingBottom: 0,
                    },
                    display: "flex",
                    flexDirection: "row",
                    gap: "1rem",
                    width: "100%",
                }}
            > */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    flex: "1 0 0",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#023",
                            fontFamily: "Roboto",
                            fontSize: "0.875rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "150%",
                        }}
                    >
                        {name}
                    </Typography>
                </Box>
                <Typography
                    sx={{
                        color: "#023",

                        fontFamily: "Roboto",
                        fontSize: "0.75rem",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "1.25rem",
                    }}
                >
                    {year}
                </Typography>
            </Box>
            {/* </CardContent> */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    alignSelf: "stretch",
                }}
            >
                {download.icon}
            </Box>
        </Card>
    );
}
